import React from "react";
import Footer from "../components/Footer";

const publications = [
  {
    title: "Using Dopants as Agents to Probe Key Electronic Properties of Organic Semiconductors",
    authors: "Fediai, Artem and Symalla, Franz and Neumann, Tobias and Wenzel, Wolfgang",
    journal: "Adv. Electron. Mater.",
    year: 2025,
    link: "https://advanced.onlinelibrary.wiley.com/doi/abs/10.1002/aelm.202400988"
  },
  {
    title: "The Importance of High-Frequency Modes in the Prediction of RISC Rates for TADF Molecules",
    authors: "Pizza, Teodoro and Capobianco, Amedeo and Troisi, Alessandro",
    journal: "J. Phys. Chem. Lett.",
    year: 2025,
    link: "https://doi.org/10.1021/acs.jpclett.5c00176"
  },
  {
    title: "High-Throughput Screening of Molecule/Polymer Photocatalysts for the Hydrogen Evolution Reaction",
    authors: "Shi, Lei and Troisi, Alessandro",
    journal: "ACS Catal.",
    year: 2025,
    link: "https://doi.org/10.1021/acscatal.5c01785"
  },
  {
    title: "Intuitive and Efficient Approach to Determine the Band Structure of Covalent Organic Frameworks from Their Chemical Constituents",
    authors: "Ding, Changchun and Xie, Xiaoyu and Chen, Linjiang and Troisi, Alessandro",
    journal: "J. Chem. Theory Comput.",
    year: 2024,
    link: "https://doi.org/10.1021/acs.jctc.3c01302"
  },
  {
    title: "37-3: Donor-Acceptor Alignment and Charge Separation in Small Molecule Organic Semiconductors",
    authors: "Fediai, Artem and Neumann, Tobias and Symalla, Franz and Strunk, Timo",
    journal: "SID Symp. Dig. Tech. Pap.",
    year: 2024,
    link: "https://sid.onlinelibrary.wiley.com/doi/abs/10.1002/sdtp.17564"
  },
  {
    title: "Guidelines for Material Design in Semitransparent Organic Solar Cells",
    authors: "Forberich, Karen and Troisi, Alessandro and Liu, Chao and Wagner, Michael and Brabec, Christoph J. and Egelhaaf, Hans Joachim",
    journal: "Adv. Funct. Mater.",
    year: 2024,
    link: "https://doi.org/10.1002/adfm.202314116"
  },
  {
    title: "45-4: Late-News Paper: On the Determination of Ionization Potentials",
    authors: "Symalla, Franz and Fediai, Artem and Neumann, Tobias and Strunk, Timo",
    journal: "SID Symp. Dig. Tech. Pap.",
    year: 2024,
    link: "https://sid.onlinelibrary.wiley.com/doi/abs/10.1002/sdtp.17597"
  },
  {
    title: "Organic super-reducing photocatalysts generate solvated electrons via two consecutive photon induced processes",
    authors: "Villa, Marco and Fermi, Andrea and Calogero, Francesco and Wu, Xia and Gualandi, Andrea and Cozzi, Pier Giorgio and Troisi, Alessandro and Ventura, Barbara and Ceroni, Paola",
    journal: "Chem. Sci.",
    year: 2024,
    link: "http://dx.doi.org/10.1039/D4SC04518A"
  },
  {
    title: "Calibration of several first excited state properties for organic molecules through systematic comparison of TDDFT with experimental spectra",
    authors: "Wu, Xia and Xie, Xiaoyu and Troisi, Alessandro",
    journal: "J. Mater. Chem. C",
    year: 2024,
    link: "http://dx.doi.org/10.1039/D4TC03511A"
  },
  {
    title: "Identification of Unknown Inverted Singlet-Triplet Cores by High-Throughput Virtual Screening",
    authors: "Omar, Ömer H. and Xie, Xiaoyu and Troisi, Alessandro and Padula, Daniele",
    journal: "J. Am. Chem. Soc.",
    year: 2023,
    link: "https://doi.org/10.1021/jacs.3c05452"
  },
  {
    title: "CoPriNet: graph neural networks provide accurate and rapid compound price prediction for molecule prioritisation",
    authors: "Sanchez-Garcia, Ruben and Havasi, Dávid and Takács, Gergely and Robinson, Matthew C and Lee, Alpha and von Delft, Frank and Deane, Charlotte M",
    journal: "Digit. Discov.",
    year: 2023,
    link: "http://dx.doi.org/10.1039/D2DD00071G"
  },
  {
    title: "DIY Virtual Chemical Libraries - Novel Starting Points for Drug Discovery",
    authors: "Takács, Gergely and Havasi, Dávid and Sándor, Márk and Dohánics, Zsolt and Balogh, György T. and Kiss, Róbert",
    journal: "ACS Med. Chem. Lett.",
    year: 2023,
    link: "https://doi.org/10.1021/acsmedchemlett.3c00146"
  },
  {
    title: "Identification via Virtual Screening of Emissive Molecules with a Small Exciton-Vibration Coupling for High Color Purity and Potential Large Exciton Delocalization",
    authors: "Xie, Xiaoyu and Troisi, Alessandro",
    journal: "J. Phys. Chem. Lett.",
    year: 2023,
    link: "https://doi.org/10.1021/acs.jpclett.3c00749"
  },
  {
    title: "Fine-tuning GPT-3 for machine learning electronic and functional properties of organic molecules",
    authors: "Xie, Zikai and Evangelopoulos, Xenophon and Omar, Ömer H. and Troisi, Alessandro and Cooper, Andrew I. and Chen, Linjiang",
    journal: "Chem. Sci.",
    year: 2023,
    link: "http://dx.doi.org/10.1039/D3SC04610A"
  },
  {
    title: "Feasibility of p-Doped Molecular Crystals as Transparent Conductive Electrodes via Virtual Screening",
    authors: "Nematiaram, Tahereh and Troisi, Alessandro",
    journal: "Chem. Mater.",
    year: 2022,
    link: "https://doi.org/10.1021/acs.chemmater.2c00281"
  },
  {
    title: "Computing Charging and Polarization Energies of Small Organic Molecules Embedded into Amorphous Materials with Quantum Accuracy",
    authors: "Armleder, Jonas and Strunk, Timo and Symalla, Franz and Friederich, Pascal and Enrique Olivares Peña, Jorge and Neumann, Tobias and Wenzel, Wolfgang and Fediai, Artem",
    journal: "J. Chem. Theory Comput.",
    year: 2021,
    link: "https://doi.org/10.1021/acs.jctc.1c00036"
  },
  {
    title: "De Novo Calculation of the Charge Carrier Mobility in Amorphous Small Molecule Organic Semiconductors",
    authors: "Kaiser, Simon and Neumann, Tobias and Symalla, Franz and Schlöder, Tobias and Fediai, Artem and Friederich, Pascal and Wenzel, Wolfgang",
    journal: "Front. Chem.",
    year: 2021,
    link: "https://doi.org/10.3389/fchem.2021.801589"
  },
  {
    title: "High-throughput virtual screening for organic electronics: A comparative study of alternative strategies",
    authors: "Omar, Ömer H. and Del Cueto, Marcos and Nematiaram, Tahereh and Troisi, Alessandro",
    journal: "J. Mater. Chem. C",
    year: 2021,
    link: "https://doi.org/10.1039/d1tc03256a"
  },
  {
    title: "Novel thermally activated delayed fluorescence materials by high-throughput virtual screening: going beyond donor-acceptor design",
    authors: "Zhao, Ke and Omar, Ömer H. and Nematiaram, Tahereh and Padula, Daniele and Troisi, Alessandro",
    journal: "J. Mater. Chem. C",
    year: 2021,
    link: "https://doi.org/10.1039/d1tc00002k"
  },
  {
    title: "On the Largest Possible Mobility of Molecular Semiconductors and How to Achieve It",
    authors: "Nematiaram, Tahereh and Padula, Daniele and Landi, Alessandro and Troisi, Alessandro",
    journal: "Adv. Funct. Mater.",
    year: 2020,
    link: "https://doi.org/10.1002/adfm.202001906"
  },
  {
    title: "Elucidating the Relationship between Multiradical Character and Predicted Singlet Fission Activity",
    authors: "Omar, Ömer H. and Padula, Daniele and Troisi, Alessandro",
    journal: "ChemPhotoChem",
    year: 2020,
    link: "https://doi.org/10.1002/cptc.202000098"
  },
  {
    title: "Singlet fission molecules among known compounds: Finding a few needles in a haystack",
    authors: "Padula, Daniele and Omar, Ömer H. and Nematiaram, Tahereh and Troisi, Alessandro",
    journal: "Energy Environ. Sci.",
    year: 2019,
    link: "https://doi.org/10.1039/c9ee01508f"
  },
  {
    title: "Built-In Potentials Induced by Molecular Order in Amorphous Organic Thin Films",
    authors: "Friederich, Pascal and Rodin, Vadim and von Wrochem, Florian and Wenzel, Wolfgang",
    journal: "ACS Appl. Mater. Interfaces",
    year: 2018,
    link: "https://doi.org/10.1021/acsami.7b11762"
  },
  {
    title: "Molecular Origin of the Anisotropic Dye Orientation in Emissive Layers of Organic Light Emitting Diodes",
    authors: "Friederich, Pascal and Coehoorn, Reinder and Wenzel, Wolfgang",
    journal: "Chem. Mater.",
    year: 2017,
    link: "https://doi.org/10.1021/acs.chemmater.7b03742"
  }
];



export default function Publications() {
  return (
    <>
    <section className="min-h-screen py-20 px-6 sm:px-8 bg-[#1A1631] text-white">
      <div className="max-w-5xl mx-auto">
		  <a
	  href="/"
	  className="text-[#EF7C34] hover:underline text-sm flex items-center mb-6"
	>
	  <span className="mr-2 text-lg">←</span> Back to main site
	</a>
        <h1 className="text-4xl md:text-5xl font-bold mb-8">
          <span className="bg-gradient-to-r from-[#EF7C34] to-[#F89B3F] bg-clip-text text-transparent">Publications</span>
        </h1>
        <p className="text-lg text-slate-300 mb-12 max-w-2xl">
          Research related to the DiaDEM<sup>™</sup> project and its partners. These publications represent our collaborative efforts across materials science, AI, and computational chemistry. They all share a common goal: expediting R&D through digital chemistry.
        </p>

        <ul className="space-y-8">
          {publications.map((pub, idx) => (
            <li
              key={idx}
              className="p-6 border border-[#EF7C34]/20 bg-[#2A2444]/60 rounded-xl shadow hover:shadow-orange-500/20 transition-all"
            >
              <h2 className="text-xl font-semibold text-orange-300 mb-2">
                {pub.title}
              </h2>
              <p className="text-sm text-slate-400 italic">{pub.authors}</p>
              <p className="text-sm text-slate-400 mb-2">
                <span className="font-medium text-white">{pub.journal}</span>, {pub.year}
              </p>
              {pub.link && (
                <a
                  href={pub.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#F89B3F] text-sm underline hover:text-[#EF7C34]"
                >
                  View Publication ↗
                </a>
              )}
            </li>
          ))}
        </ul>
      </div>
    </section>

          {/* ✅ Minimal Footer always sits outside main content */}
      <Footer />
    </>
  );
}